import './CTA.css';

import React from 'react';
import { CSSTransition } from 'react-transition-group';
import STATUS from '../Game/constants';

const CTA = (props) => {
  return (
    <CSSTransition
      in={props.status === STATUS.CTA}
      timeout={350}
      exit={false}
      unmountOnExit
      classNames="fade-up">
      <div className="CTA flex flex--align-c flex--justify-c">
        <div className="wrapper">
          <div>
            <h1 className="title-lg">Well played!</h1>
            <h2 className="title-sm">You successfully identified the positive gambling behaviours.</h2>

            <button className="button" onClick={props.callback}>Play again</button>
          </div>

          <div>
            <div className="content">
              <p>Now that you’ve got the basics, go deeper into a few responsible gambling concepts to help you keep gambling fun.</p>
            </div>

            <a href="https://www.gamesense.com/play-better.html" target="_blank" rel="noopener" className="button">Learn more</a>
          </div>
        </div>
      </div>
    </CSSTransition>
  )
}

export default CTA;



// WEBPACK FOOTER //
// ./src/components/rlgl/CTA/CTA.js